import { defineComponent as _defineComponent } from 'vue'
import {
  HeadingDisplay,
  BaseText,
  ButtonContainer,
  ButtonPrimary,
  Modal,
  Link
} from '@warrenbrasil/nebraska-web';


export default /*#__PURE__*/_defineComponent({
  __name: 'SendCertificateModal',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ['close'],
  setup(__props: any, { emit }) {





const handleClose = () => {
  emit('close');
};

return { __sfc: true,emit, handleClose, HeadingDisplay, BaseText, ButtonContainer, ButtonPrimary, Modal, Link }
}

})